import SearchIcon from "@mui/icons-material/Search";
import { Grid, Stack } from "@mui/material";
import { t } from "i18next";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import StatusCard from "../../../components/Dashboard/StatusCard";
import CustomRangePicker from "../../../components/DateRangePicker";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { CURRENCY } from "../../../constants/Variables";
import { getCompanyReport } from "../../../services/company/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import PopularServices from "./PopularServices";
import ReportChart from "./ReportChart";
import ServicePiewChart from "./ServicePieChart";

function CompanyReports() {
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(1, "month"));
  const [endDate, setEndDate] = useState(moment());
  const [reportData, setReportData] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    if (userData && startDate && endDate) {
      fetchCompanyReport(startDate, endDate);
    }
  }, [userData]);

  const fetchCompanyReport = async (startDate, endDate) => {
    let query = {
      startDate,
      endDate,
    };
    try {
      setIsLoading(true);
      const response = await getCompanyReport(userData?.adminId, query);
      if (response.data.status === "success") {
        const data = response.data.data;
        const finalChartData = data?.companyDailyEarning?.map((val, ind) => {
          return {
            orders: val.totalAppointments,
            earnings: val.totalEarnings,
            date: new Date(val._id).getTime(),
          };
        });
        setReportData(data);
        setChartData(finalChartData);
        setAllServices(data.popuparServices);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const cardData = [
    {
      primary: "totalAppointments",
      secondary: "totalAppointmentsScheduled",
      value: reportData?.totalAppointments || 0,
    },
    {
      primary: "completeAppointments",
      secondary: "totalAppointmentsCompleted",
      value: reportData?.completedAppointments || 0,
    },
    {
      primary: "earnings",
      secondary: "totalEarnings",
      value: `${CURRENCY} ${
        reportData?.companyEarnings[0]?.totalCompanyEarnings || 0
      }`,
    },
  ];

  const handleFilterData = () => {
    fetchCompanyReport(startDate, endDate);
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Stack direction={"row"} alignItems={"center"}>
          <CustomRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            stackProps={{
              borderRadius: "6px 0px 0px 6px",
              border: "1px solid #dddddd",
            }}
          />
          <GlobalButton
            endIcon={<SearchIcon />}
            handleClickBtn={handleFilterData}
            styleProps={{
              color: "primary",
              width: "auto",
              borderRadius: "0px 6px 6px 0px",
              minWidth: 45,
              height: "42px",
              "& .MuiButton-icon": {
                marginLeft: "0px",
              },
            }}
          />
        </Stack>
      </Stack>
    );
  };

  console.log(allServices,"HELLL YEAH")

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("reportingAndAnalytics")}
        secondaryHeading={t("accessReports")}
        headProps={renderRightPart()}
      >
        <Grid container mt={3} spacing={1}>
          {cardData?.map((val, _ind) => {
            return <StatusCard item={val} index={_ind} />;
          })}
        </Grid>

        <ReportChart chartData={chartData} isLoading={isLoading} />

        <Grid container mt={3} spacing={1}>
          <Grid item xs={12} md={8}>
            <PopularServices
              allServices={reportData?.popuparServices}
              isLoading={isLoading}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ServicePiewChart allServices={allServices} isLoading={isLoading} />
          </Grid>
        </Grid>
      </AppContainer>
    </NavigationDrawer>
  );
}

export default CompanyReports;
